export default __webpack_public_path__ + "static/media/diy_phone.6cae02d4.png";